// extracted by mini-css-extract-plugin
module.exports = {"root":"tweet-info-created-at_root__zUN4W"};